import script from "./HomeSliderComparison.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeSliderComparison.vue?vue&type=script&setup=true&lang=js"

import "./HomeSliderComparison.vue?vue&type=style&index=0&id=442b50d7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-442b50d7"]])

export default __exports__